const SUITS = ['S', 'H', 'D', 'C'];
const RANKS = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];

// Cryptographically secure random integer between 0 and max (exclusive)
// Uses rejection sampling to completely eliminate modulo bias
const getSecureRandomInt = (max) => {
    const array = new Uint32Array(1);
    const limit = 0x100000000 - (0x100000000 % max);
    
    let r;
    do {
        window.crypto.getRandomValues(array);
        r = array[0];
    } while (r >= limit); 
    
    return r % max;
};

// Strict Fisher-Yates Shuffle using Cryptographic Randomness
export const shuffleDeck = () => {
    let deck = [];
    for (let s of SUITS) {
        for (let r of RANKS) {
            deck.push({ suit: s, rank: r });
        }
    }
    for (let i = deck.length - 1; i > 0; i--) {
        const j = getSecureRandomInt(i + 1);
        [deck[i], deck[j]] = [deck[j], deck[i]];
    }
    return deck;
};

// Formats a hand array into a BBO-compliant LIN string (e.g., SAKQ...H...)
const formatHandLIN = (hand) => {
    const getSuit = (suit) => hand.filter(c => c.suit === suit)
        .sort((a, b) => RANKS.indexOf(a.rank) - RANKS.indexOf(b.rank)) // Sort A down to 2
        .map(c => c.rank).join('');
    return `S${getSuit('S')}H${getSuit('H')}D${getSuit('D')}C${getSuit('C')}`;
};

export const generateBoardLIN = (boardNum) => {
    const deck = shuffleDeck();
    
    // Deal 13 cards to each seat
    const hands = {
        S: deck.slice(0, 13),
        W: deck.slice(13, 26),
        N: deck.slice(26, 39),
        E: deck.slice(39, 52)
    };

    // Standard duplicate board progression for Dealer and Vulnerability
    const dealerInt = ((boardNum - 1) % 4) + 1; // 1=S, 2=W, 3=N, 4=E
    const vuls = ['o', 'n', 'e', 'b', 'n', 'e', 'b', 'o', 'e', 'b', 'o', 'n', 'b', 'o', 'n', 'e'];
    const vul = vuls[(boardNum - 1) % 16];

    const hS = formatHandLIN(hands.S);
    const hW = formatHandLIN(hands.W);
    const hN = formatHandLIN(hands.N);
    const hE = formatHandLIN(hands.E);

    // BBO .lin format expects the dealer int followed by S, W, N. (E is inferred, but we include it for safety)
    const bboMdStr = `${dealerInt}${hS},${hW},${hN},${hE}`;

    return {
        boardNum,
        dealerInt,
        vul,
        linString: `qx|o${boardNum}|md|${bboMdStr}|rh||ah|Board ${boardNum}|sv|${vul}|pg||`,
        internalHands: bboMdStr
    };
};

export const generateLinFileContent = (start, end) => {
    let content = "";
    for (let i = start; i <= end; i++) {
        content += generateBoardLIN(i).linString + "\n";
    }
    return content;
};

export const downloadLinFile = (content, filename) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};